import { Moment } from 'moment';
import { ChangeEvent, CSSProperties, ReactNode } from "react";

// TODO : IMPLEMENTS WITHOUT ANY
export type TNotifTable = {
	promo: Array<any>,
	permintaanLayanan: Array<any>,
	amandemen: Array<any>,
	subscription: Array<any>,
	promoToReadCount: number,
	permintaanLayananToReadCount: number,
	amandemenToReadCount: number,
	subscriptionToReadCount: number
}

export type TNotificationPayload = {
	menu: TMenuNotification,
	customerNumber: string | null,
	userID: string | null
}

export type TMenuNotification = {
	subscription: string,
	serviceRequest: string,
	amendment: string,
	promo: string
}

export type TPaymentHistoryData = Array<{
	cusT_AREA_ID: string;
	area: string;
	cusT_NUMBER: number;
	paY_DATE: string;
	paY_CURR_CODE: string;
	paY_AMT: number;
	chanel: string;
	paY_METHOD: string;
	periodE_BAYAR: string;
	cusT_NAME: string;
}>;

export type TPaymentHistoriesResponse = {
	columns: Array<any>;
	draw: number;
	recordsTotal: number;
	recordsFiltered: number;
	data: Array<TPaymentHistoryData>;
	error: any;
};

export interface IHeader {
	header: string;
	key: string;
	width: number;
	cb?: () => 0;
}
export interface ISelectionProps {
	className?: string;
	value?: any;
	name?: string;
	onChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
	invalidParam?: boolean;
	disabled?: boolean;
	placeHolder?: string;
	children?: ReactNode;
	defaultValue?: string;
	style?: CSSProperties;
	validations?: {
		valid: boolean;
		data: any;
		errors: Record<string, any>;
	};
	validationName?: string;
	validationStyle?: CSSProperties;
}

export type ValidateResultType = {
	valid: boolean,
	data: any,
	errors: any
}

export interface ISubmitPaymentPlanPayload {
	invoiceId: string;
	custNumber: string;
	paymentMethod: string;
	gasSubcribtionBillIdr: number;
	gasSubcribtionBillUsd: number;
	administrativeCostsIdr: number;
	administrativeCostsUsd: number;
	totalBillIdr: number;
	totalBillUsd: number;
	status: string;
	dateSubmitted: Moment;
	customerName: string;
	vaIdr: string;
	vaUsd: string;
	amount: number;
	paymentDate: string;
	amountCurrency: string;
	jisdor: number;
	custGroup: string;
	cm: string;
	regionId?: string;
	areaId: string;
	invoicePeriod: string | null;
}

export type GroupedPerjanjianType = {
	periodStartDate: string | Moment | null;
	periodEndDate: string | Moment | null;
	data: Array<PerjanjianType>
}

export type StoreMailType = {
	createdOn: string | Moment;
	mailAddress: string;
	subject: string;
	template: string;
	fileName?: string;
	filePath?: string;
	// status: number;
};

export type CurrentFuelType = {
	bahanBakar: BahanBakarType;
	peralatan: PeralatanType;
};

export type EquipmentType = {
	id: string | null;
	formulirID: string | null;
	nama: string;
	jumlah: number | string;
	kapasitas: number | string;
	jamOperasi: number;
	pemakaianMaksimum: any;
	isActive: number;
	// new form mockup
	startDate: string | null | Moment;
	endDate: string | null | Moment;
	penggunaanGasRataRata: number | null;
	unitGasRataRata: string | null;
	penggunaanGasMinimum: number | null;
	unitGasMinimum: string | null;
	penggunaanGasMaksimum: number | null;
	unitGasMaksimum: string | null;
	polaOperasiJamHari: string | null;
	polaOperasiHariMinggu: string | null;
	tekananOperasi: number | null;

	// missing type
	amandemenID: string | null;
	createdBy: string | null;
	kapasitasUnit: string | null;
	createdOn: string | Moment;
};

export type PJBGType = {
	docNumber: string;
	skemaPembayaran: string;
	levelHirarki: string;
	lokasiTitikSerah: string;
	tglPenyerahanGas: string | null;
	tempatPenyerahanGas: string | null;
	startDate: string;
	endDate: string;
};

export type PeralatanType = {
	id: string | null;
	capelID: string;
	peralatan: string;
	jumlah: number;
	kapasitasVolume: number;
	kapasitasUnit: string;
	polaJam: number;
	polaHari: number;
	pemakaianVolume: number;
	pemakaianUnit: string;
	isActive: number;
};

export type BahanBakarType = {
	id: string | null;
	capelID: string;
	nama: string;
	kapasitasVolume: number;
	kapasitasUnit: string;
	polaJamHari: number;
	polaHariMinggu: number;
	bahanBakar: string;
	harga: number;
	penggunaanVolume: number;
	penggunaanUnit: string;
	isActive: number;
	unitHarga: string;
};

export type BahanPangsaType = {
	id: string | null;
	capelID: string;
	tableType: string;
	negara: string;
	persentase: number;
	isActive: number;
};

export type BahanBakarExistingType = {
	id: string | null;
	capelID: string;
	nama: string;
	pemasok: string;
	isActive: number;
};

export type JenisProdukType = {
	id?: string | null;
	capelID: string;
	nama: string;
	jumlah: number;
	harga: number;
	isActive: number;
	satuan: string;
};

export type FormulirType = {
	formulirData: FormulirDataType;
	peralatan: any;
};

export type AmandemenType = {
	verifiedIds: VerifiedIds;
	listAmandemen: DefaultResponseType;
	formulirAmandemenData: FormulirAmandemenType;
	peralatan: EquipmentType[];
	perjanjian: Array<PerjanjianType>;
	groupedPerjanjian: Array<GroupedPerjanjianType>;
	validations: ValidateResultType
};

export type KK0DataType = {
	capelData: CapelDataType;
	kk0Data: any;
	jenisProduk: any;
	bahanBakarExisting: any;
	bahanPangsa: any;
	bahanBakar: any;
	jenisPeralatan: any;
	peralatanKomersial: any;
};

export type IdentifyType = {
	acc_id: string;
	sor: string;
	area: string;
	area_code: string;
	cust_number: string;
	cust_name_decrypt: string;
	cm: string;
	status: string;
	cust_type: string;
	sector: string;
	description: string;
	tax_identifier_decrypt: string;
	email_decrypt: string;
	website: string;
	bussiness_group: string;
	gas_source: string;
	industry_sector: string;
	start_Date: Date | null;
	end_DAte: Date | null;
	group_book: string;
	cust_group: string;
	personal_identifier: string;
	addr_bill_to_decrypt: string;
	addr_premise_decrypt: string;
	city: string;
	district: string;
	sub_district: string;
	price_code: string;
	min_contract: number | null;
	max_contract: number | null;
	contact_person_decrypt: string;
	home_phone_decrypt: string;
	mobile_phone_decrypt: string;
	corporate_flag: string;
	product_name: string;
	notifikasiLastSeen: TNotificationPayload | null;
};

export type AreaType = {
	id: string;
	regionID: string;
	city: string;
	areaName: string;
};

export type KK0FormType = {
	id?: string | null;
	capelID: string;
	regionID: string | null;
	docNumber: string;
	produkLayanan: string;
	tujuanPenggunaan: string;
	tujuanPenggunaanLainnya: string;
	informasiTambahan: string;
	tanggalSurvei: string | null;
	pemberiData: string;
	petugasSurvei: string;
	docStatus: string;
	isActive: boolean | null;
	createdBy: string;
	createdOn: string | null;
	modifiedBy: string;
	modifiedOn: string | null;
	kebutuhanJasa: string;
	areaID: string | null;
	efisiensiDiharapkan: number | null;
};

export type FormulirAmandemenType = {
	id: string | null;
	gasAvgUsagePlan: number | null;
	gasAvgUsagePlanUnit: string | null;
	penyebabAmandemen: string | null;
	pemberlakuanAmandemen: string | null;
	createdBy: string | null;
	modifiedBy: string | null;
	docStatus: string | null;
	docNumber: string | null;
	regionID: string | null;
	areaID: string | null;
	fullName: string | null;
	jabatan: string | null;
	namaPerusahaan: string | null;
	acC_ID: string | null;
	cusT_NUMBER: string | null;
	area: string | null;
	area_code: string | null;
	no_Telp: string | null;
	email: string | null;
	polaOperasiJamHari: number | null;
	polaOperasiHariMinggu: number | null;
	CurrentDate: string | null | Moment;
	position: string | null;
	produk: string;
	subProduk: string;
};

export type VerifiedIds = {
	capelID: string | null;
	kK0ID: string | null;
	formulirID: string | null;
};

export type PeralatanKomersial = {
	CapelID: string | null;
	kK0ID: string | null;
	formulirID: string | null;
	isActive: number | null;
	startDate: string | null | Moment;
	endDate: string | null | Moment;
	penggunaanGasRataRata: number | null;
	unitPenggunaanGasRataRata: string;
	unitPenggunaanGasMinimum: string;
	unitPenggunaanGasMaksimum: string;
	penggunaanGasMinimum: number | null;
	penggunaanGasMaksimum: number | null;
	polaOperasiJamHari: number;
	polaOperasiHariMinggu: number;
	tekananOperasi: number | null;
};

export type FormulirDataType = {
	id: string | null;
	capelID: string | null;
	regionID: string | null;
	docNumber: string;
	skemaPembayaran: string;
	levelHirarki: string;
	lokasiTitikSerah: string;
	tglPenyerahanGas: string | null | Moment; // or Date if you'll be working with Date objects
	tempatPenyerahanGas: string;
	codeHargaGas: string;
	periode: string; // or number if it's numeric
	startDate: string | null | Moment; // or Date
	endDate: string | null | Moment; // or Date
	basisKontrak: string;
	docStatus: string;
	isActive: number; // or boolean if it's true/false
	createdBy: string;
	modifiedBy: string;
	pjbgType: string;
	layananTambahanNo: string;
	layananTambahanTgl: string | null | Moment; // or Date
	penyebabAmandemen: string;
	berlakuStart: string | Moment; // or Date
	berlakuEnd: string | Moment; // or Date
	areaID: string | null | Moment;

	penggunaanGasMaksimum: number;
	unitGasMaksimum: string;
	penggunaanGasMinimum: number;
	unitGasMinimum: string;
	penggunaanGasRataRata: number;
	unitGasRataRata: string;

	statusBangunan: string;
	startDateEstimation: string | Moment;
	sektorKomersial: string;
	sektorIndustri: string;
	sektorTransportasi: string;
	peralatanPenggunaGas: string;
	peralatanPenggunaGasLainnya: string;
	// tekananOperasi: number;
	gasMaksimumTambahan: number;
	gasMinimumTambahan: number;
	gasRataRataTambahan: number;
	polaOperasiJamHariTambahan: string;
	polaOperasiHariMingguTambahan: string;
	tekananOperasiTambahan: number;
	startDateAdditional: string | Moment;
	endDateAdditional: string | Moment;
	postalCodeInstallation: string;
	phoneInstallation: string;
	//ADDED WHEN DEVELEOP DOC PREVIEW
	createdOn: string | null;
	// gasEquipmentDetails: Array<GasEquipmentDetail>;
};

export type PerjanjianType = {
	id: string | null;
	formulirID: string | null;
	perihal: string | null | undefined;
	perjanjianStart: string | Moment | null;
	perjanjianEnd: string | Moment | null;
	perjanjianPemakaianMaksimum: number | null;
	usulanStart: string | Moment | null;
	usulanEnd: string | Moment | null;
	usulanPemakaianMaksimum: number | null;
	keterangan: string | null;
	basisKontrak: string | null;
	perjanjian: string | null;
	produk: string | null;
	perjanjianPemakaianMinimum: number | null;
	usulanPemakaianMinimum: number | null;
	perjanjianTekananOutlet: number | null;
	usulanTekananOutlet: number | null;
	usulanProduk: string | null;
	peralatanPenggunaGas: string | null;
	usulanPeralatanPenggunaGas: string | null;
	subProduk: string | null;
	usulanSubProduk: string | null;
	isActive: number | null;
	createdBy: string | null;
	modifiedBy: string | null;
	gasAvgUsagePlan: number | null;
	gasAvgUsagePlanUnit: string;
	periodStartDate: string | Moment;
	periodEndDate: string | Moment;
};

export type CapelDataType = {
	id: string | null;
	userID: string | null;
	custNumber: string;
	idPelanggan: string;
	namaPerusahaan: string;
	picFirst: string;
	picLast: string;
	noHP: string;
	email: string;
	jabatan: string;
	kantorNegara: string;
	kantorProvinsi: string;
	kantorKota: string;
	kantorDistrik: string;
	kantorSubDistrik: string;
	kantorAlamat: string;
	kantorNoTelp: string | number;
	kantorPostalCode: string;
	kantorBuilding: string;
	kantorFloor: string;
	kantorHouseName: string;
	kantorStreetName: string;
	kantorBlock: string;
	kantorHouseNumber: string;
	kantorRT: string;
	kantorRW: string;
	kantorType: string;
	kantorAdditionalInfo: string;
	kantorDescription: string;
	kantorCoordinateSource: string;
	kantorCoordinateLatitude: string;
	kantorStatusKepemilikan: string;
	kantorCoordinateLongitude: string;
	kantorPIC: string;
	kantorEmail: string;
	kantorJabatan: string;
	pabrikNegara: string;
	pabrikProvinsi: string;
	pabrikKota: string;
	pabrikDistrik: string;
	pabrikSubDistrik: string;
	pabrikAlamat: string;
	pabrikNoTelp: string | number;
	pabrikPostalCode: string;
	pabrikBuilding: string;
	pabrikFloor: string;
	pabrikHouseName: string;
	pabrikStreetName: string;
	pabrikBlock: string;
	pabrikHouseNumber: string;
	pabrikRT: string;
	pabrikRW: string;
	pabrikType: string;
	pabrikAdditionalInfo: string;
	pabrikDescription: string;
	pabrikCoordinateSource: string;
	pabrikCoordinateLatitude: string;
	pabrikStatusKepemilikan: string;
	pabrikCoordinateLongitude: string;
	pabrikPIC: string;
	pabrikEmail: string;
	pabrikJabatan: string;
	longitude: string;
	latitude: string;
	jenisProduk: string;
	willingnessToPay: string;
	jarakPipaTerdekat: number;
	bbExisting: string;
	bbSupplier: string;
	bbDayaListrik: number;
	bbKonsumsiListrik: number;
	sektorUsaha: string;
	jumlahKaryawan: number;
	jumlahShift: number;
	polaOperasiJamHari: string;
	polaOperasiHariMinggu: string;
	waktuBebanPuncakDari: string;
	waktuBebanPuncakKe: string;
	isActive: number;
	createdBy: string;
	createdOn: string;
	modifiedBy: string;
	modifiedOn: string;
	satuanMataUang: string;
	passwordCapel: string | null;
	aktaPabrik: string;
	aktaPabrikNo: string;
	aktaPabrikTanggal: string | null;
	aktaKantor: string;
	aktaKantorNo: string;
	aktaKantorTanggal: string | null;
	pejabatTandaTangan: string;
	noRefPelanggan: string;
	unitDayaListrik: string;
	postalCode: string;
	npwp: string;
};

export type SimplePayloadType = {
	draw: number | string;
	start: number | string;
	length: number | string;
	order: any;
	search: SimplePayloadSearch;
	columns: any;
	advSearch: any;
	idParent: number | string;
};

export type DefaultResponseType = {
	columns: [];
	data: any;
	draw: number;
	error: any;
	recordsFiltered: number;
	recordsTotal: number;
};

export type InvoiceData = {
	areA_CODE: string;
	area: string;
	bilL_PERIOD: string;
	bilL_TYPE_DESC: string | null;
	currencY_CODE: string;
	cusT_GROUP: string;
	cusT_NUMBER: string;
	cusT_TYPE: string;
	inV_AMOUNT: number;
	inV_ID: number;
	inV_PERIOD: string;
	inV_TRX_CODE: number;
	inV_TRX_TYPE: string;
	inkaso: string;
	jrek: string;
	keterangan: string;
	oustanding: number;
	paymenT_AMOUNT: number;
	paymenT_DATE: string;
	period: string;
	status: string;
	usagE_SOURCE: string | null;
	volumE_NORMAL: number;
	volumE_OVER_USAGE: number;
	volumE_USAGE: number;
};

export type TServices = {
	custNumber: string;
	dateSubmitted: string | Moment;
	status: string;
	sumCost: number;
	dateRequired: string;
	productId: string;
	productName: string;
	productPrice: string;
	currencyCode: string;
	custName: string;
	position: string;
	address: string;
	customerName: string;
	email: string;
	phoneNumber: string;
	postalCode: string;
	areaID: string;
};

type SimplePayloadSearch = {
	value: string;
	regex: boolean;
	startDate?: string;
	endDate?: string;
	selectedMonths?: string;
	status?: string;
};

type Constant = {
	defaultResponse: DefaultResponseType;
	simplePayload: SimplePayloadType;
};

const constants: Constant = {
	defaultResponse: {
		columns: [],
		data: [],
		draw: 0,
		error: null,
		recordsFiltered: 0,
		recordsTotal: 1,
	},
	simplePayload: {
		draw: 0,
		start: 0,
		length: 0,
		order: [],
		search: {
			value: '',
			regex: true,
		},
		columns: [],
		advSearch: {},
		idParent: 0,
	},
};

export default constants;
